const __stack=[];function pushStack(n){__stack.push(n)}function popStack(){__stack.pop()}function getStack(){return[...__stack]};
function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.check=v=>{if(ex===null)return true;return typeof v===typeof ex}}return t};
function FunctionPredicate(n,s,b){if(Array.isArray(s)&&b){const f=(...a)=>FunctionPredicate(n,b(...a));f.typeParamNames=s.map(p=>Array.isArray(p)?p[0]:p);f.description=n;f.__runtimeType=true;return f}const spec=typeof s==='function'?{}:s||{};return{description:n,params:spec.params||{},returns:spec.returns,returnContract:spec.returnContract||'assertReturns',check:v=>typeof v==='function',__runtimeType:true}};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {pushStack,popStack,getStack,Type,FunctionPredicate};
/* tjs <- registry.ts */

import { XinObject, XinProxy, XinBinding } from './xin-types'

export const registry = {};

let _xin = null;

/* line 12 */
/* TODO: TS types degraded — xin: XinProxy<XinObject> */
export function setXinProxy(xin) {
  try {
  __tjs.pushStack('registry.ts:11:setXinProxy');
  if (xin instanceof Error) return xin;

    _xin = xin;

  } finally { __tjs.popStack(); }
}
setXinProxy.__tjs = {
  "params": {
    "xin": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "registry.ts:11"
}

/* line 16 */
/* TODO: TS types degraded — return: XinProxy<XinObject> */
export function getXinProxy() {
    if (_xin === null) {
        throw new Error('xin proxy not initialized');
    }
    return _xin;
}
getXinProxy.__tjs = {
  "params": {},
  "source": "registry.ts:17"
}

const BindFunc = FunctionPredicate('BindFunc', { params: { element: {}, path: '', binding: null, options: null } })

const OnFunc = Type('OnFunc')

let _bind = null;

let _on = null;

/* line 37 */
/* TODO: TS types degraded — on: OnFunc */
export function setBindFunctions(bind, on) {
  try {
  __tjs.pushStack('registry.ts:34:setBindFunctions');
  if (bind instanceof Error) return bind;
  if (on instanceof Error) return on;

    _bind = bind;
    _on = on;

  } finally { __tjs.popStack(); }
}
setBindFunctions.__tjs = {
  "params": {
    "bind": {
      "type": {
        "kind": "any"
      },
      "required": true,
      "default": null
    },
    "on": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "registry.ts:34"
}

/* line 42 */
export function getBind() {
    if (_bind === null) {
        throw new Error('bind not initialized');
    }
    return _bind;
}
getBind.__tjs = {
  "params": {},
  "returns": {
    "type": {
      "kind": "any"
    }
  },
  "unsafeReturn": true,
  "source": "registry.ts:40"
}

/* line 49 */
/* TODO: TS types degraded — return: OnFunc */
export function getOn() {
    if (_on === null) {
        throw new Error('on not initialized');
    }
    return _on;
}
getOn.__tjs = {
  "params": {},
  "source": "registry.ts:49"
}